import { Button, flex, IconFont, Input, pointer } from '@byecode/ui'
import styled from 'styled-components'

export const Icon = styled(IconFont)<{ size?: number; color?: string }>`
    font-size: ${({ size }) => size ?? 16}px;
    ${pointer}
    color: ${({ color }) => color ?? 'var(--color-gray-400)'};
`

export const ToolContainer = styled.div`
    display: flex;
    gap: 12px;
    padding: 0 12px;
    margin: 0 12px;
    margin-top: 8px;
    height: 60px;
    align-items: center;
    border-radius: 12px;
    border: 1px solid var(--color-gray-200);
    background: var(--color-white);

    &.hoverStyle {
        cursor: pointer;

        &:hover {
            background: var(--color-gray-100);
        }
    }
`
